import { Component, Input } from '@angular/core';

@Component({
    selector: 'chassis-core-two-column-layout',
    templateUrl: './two-column-layout.component.html',
    styleUrls: [ './two-column-layout.component.scss' ]
})
export class TwoColumnLayoutComponent {

    @Input() containers: Array<any> = [];

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/two-column-layout/two-column-layout.component.ts